import {Navigate} from 'react-router-dom';
import {useAppSelector} from "./redux";

const PrivateRoute = ({ children }) => {
    const token = useAppSelector(state => state.account.token);

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default PrivateRoute;
